import { baseApi } from "@/services/api/baseApi";

export const authApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * Session watchdog. The old app polled this with a 30s `setInterval` buried
     * in the sidebar, which re-read the cached result and so never actually
     * revalidated. RTK Query's own `pollingInterval` does the refetch.
     */
    authStatus: builder.query({
      query: () => ({ url: "/auth/status", method: "GET" }),
      providesTags: [{ type: "AuthStatus", id: "ALL" }],
    }),

    logout: builder.mutation({
      query: () => ({ url: "/auth/logout", method: "POST" }),
    }),
  }),
});

export const { useAuthStatusQuery, useLogoutMutation } = authApi;
